import React from 'react';
import { Alert } from 'antd';
import { observer, inject } from 'mobx-react';

@inject('globalStore')
@observer
class Alarm extends React.Component {
  render() {
    const {
      alarmStatus,
      alarmTitle,
      alarmDescription,
      hideAlarm
    } = this.props.globalStore;
    return (
      <div>
        {alarmStatus && (
          <Alert
            hidden={!alarmStatus}
            message={alarmTitle}
            description={alarmDescription}
            type="error"
            closable
            closeText="已阅读,关闭"
            onClose={() => hideAlarm}
            showIcon
          />
        )}
      </div>
    );
  }
}
export default Alarm;



// WEBPACK FOOTER //
// ./src/components/Alarm.js